import videojs from 'video.js';
import { getPresentationId, QueryStringParamProvider } from '../../implementations/player-page/helpers.js';

export class PlaylistPluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPresentation(onLoadPresentation.bind(player));
    }
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    const paramProvider = new QueryStringParamProvider(location.search);
    return paramProvider.getParam("playlistid");
}

async function onLoadPresentation(presentationId, playCoverData, presentationData) {
    const player = this;

    if (shouldLoad(...arguments)) {
        if (!videojs.getPlugin('playlist')) {
            const { PlaylistPlugin } = await import(/* webpackChunkName: 'playlist' */ './playlist.js');
            player.registerPlugin('playlist', PlaylistPlugin);
        }

        const paramProvider = new QueryStringParamProvider(location.search);
        const playlistId = paramProvider.getParam("playlistid");
        const homePresentationId = getPresentationId(location.pathname, window.SiteData?.PresentationId);       
        const isOnMenuPage = (presentationId == homePresentationId);        

        if (isOnMenuPage) {
            const loopParam = paramProvider.getParam("loop");
            const isHomeLooping = (loopParam === "true");

            player.banner().isLooping = isHomeLooping
        }

        //check the metadata to know if we should render in 360 or not
        const is360 = presentationData.metadata.is360Video;

        //grab the default thumbnail image so that can be rendered if a presentation has no thumbnail
        const defaultImgSrc = playCoverData.defaultThumbnailUrl;

        player.playlist().init(playlistId, presentationId, is360, defaultImgSrc);
    }
}
